import $ from 'jquery';
import Swal from 'sweetalert2';

export function initChunkImport() {
    $(document).on('submit', '#formGlobalImportExcel', async function(e) {
        e.preventDefault();
        
        const $form = $(this);
        const actionUrl = $form.attr('action');
        const chunkUrl = actionUrl + 'Chunk'; // Requires backend endpoint /importChunk matching /import
        
        const $submitBtn = $form.find('button[type="submit"]');
        const $progressDiv = $('#importProgress');
        const $progressBar = $progressDiv.find('.progress-bar');
        const $statusText = $('#importStatus');
        
        $submitBtn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-2"></span> Mengunggah...');
        $progressDiv.removeClass('d-none');
        $progressBar.css('width', '5%').text('5%');
        $statusText.text('Mengunggah file ke server...');
        
        const formData = new FormData(this);
        
        try {
            // 1. Upload File & Get Metadata
            const resUpload = await fetch(actionUrl, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': $('meta[name="X-CSRF-TOKEN"]').attr('content')
                },
                body: formData
            });
            
            if (!resUpload.ok) {
                const errText = await resUpload.text();
                throw new Error('Gagal mengunggah file. Server merespon dengan error.');
            }

            const dataUpload = await resUpload.json();
            
            if (dataUpload.status !== 'success') {
                throw new Error(dataUpload.message || 'Gagal mengunggah file.');
            }
            
            const fileName = dataUpload.file_name;
            const totalDataRows = dataUpload.total_rows;
            
            if (totalDataRows <= 0) {
                Swal.fire('Info', 'File Excel kosong atau tidak memiliki baris data (hanya header).', 'info');
                resetImportModal();
                return;
            }
            
            // 2. Process in Chunks
            let startRow = 2; // Data starts at row 2 (row 1 is header)
            const chunkSize = 100; // 100 rows per chunk
            let totalProcessed = 0;
            let allErrors = [];
            
            $progressBar.css('width', '10%').text('10%');
            $statusText.text(`Mempersiapkan proses 0 dari ${totalDataRows} baris...`);
            
            while (startRow <= totalDataRows + 1) { // +1 because row 1 is header
                const formDataChunk = new FormData();
                formDataChunk.append('file_name', fileName);
                formDataChunk.append('start_row', startRow);
                formDataChunk.append('chunk_size', chunkSize);
                
                const resChunk = await fetch(chunkUrl, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-TOKEN': $('meta[name="X-CSRF-TOKEN"]').attr('content')
                    },
                    body: formDataChunk
                });
                
                if (!resChunk.ok) {
                    throw new Error(`Gagal memproses baris ${startRow}. Server error.`);
                }

                const dataChunk = await resChunk.json();
                
                if (dataChunk.status !== 'success') {
                    throw new Error(dataChunk.message || `Gagal memproses baris ${startRow}`);
                }
                
                totalProcessed += dataChunk.processed;
                if (dataChunk.errors && dataChunk.errors.length > 0) {
                    allErrors = allErrors.concat(dataChunk.errors);
                }
                
                let progressPercent = 10 + Math.floor(((startRow - 2 + chunkSize) / totalDataRows) * 90);
                if (progressPercent > 100) progressPercent = 100;
                
                const currentProcessed = Math.min((startRow - 2 + chunkSize), totalDataRows);
                $progressBar.css('width', `${progressPercent}%`).text(`${progressPercent}%`);
                $statusText.text(`Memproses ${currentProcessed} dari ${totalDataRows} baris...`);
                
                startRow += chunkSize;
            }
            
            // 3. Finished
            $progressBar.css('width', '100%').text('100%');
            $statusText.text('Selesai!');
            
            let finalMessage = `Berhasil mengimpor <b>${totalProcessed}</b> baris.`;
            let swalIcon = 'success';
            
            if (allErrors.length > 0) {
                swalIcon = 'warning';
                finalMessage += `<br><br><div class="text-start" style="max-height: 200px; overflow-y: auto; font-size: 0.85em; background: #f8d7da; color: #842029; padding: 10px; border-radius: 5px; border: 1px solid #f5c2c7;">` + 
                                `<b>Terdapat beberapa peringatan/error:</b><br>` + 
                                allErrors.join('<br>') + 
                                `</div>`;
            }
            
            Swal.fire({
                title: 'Import Selesai',
                html: finalMessage,
                icon: swalIcon,
                confirmButtonText: 'Tutup'
            }).then(() => {
                window.location.reload();
            });
            
        } catch (err) {
            console.error(err);
            Swal.fire('Error', err.message, 'error');
            resetImportModal();
        }
        
        function resetImportModal() {
            $submitBtn.prop('disabled', false).html('<i class="bi bi-cloud-upload me-1"></i> Mulai Import');
            $progressDiv.addClass('d-none');
            $progressBar.css('width', '0%').text('0%');
            $form[0].reset();
        }
    });
}
